


















































































































































































































































































































































































































import SearchBuilder from "@/builder/SearchBuilder";
import {
  buildSalesOrderFormDto,
  buildTruckingSalesOrderLineFormDto,
} from "@/builder/trucking-sales-order/TruckingSalesOrderBuilder";
import currencyFilter from "@/filters/currency.filter";
import { displayNeg } from "@/helpers/common";
import { debounce } from "@/helpers/debounce";
import { generateUUID } from "@/helpers/uuid";
import { useContactData } from "@/hooks/contact";
import { useTax, useTaxRate } from "@/hooks/tax";
import useAsset from "@/hooks/useAsset";
import useCalculator from "@/hooks/useCalculator";
import useCurrency from "@/hooks/useCurrency";
import usePreferences from "@/hooks/usePreferences";
import useSalesOrder from "@/hooks/useSalesOrder";
import useSalesOrderCalculation from "@/hooks/useSalesOrderCalculation";
import useTruckingSalesOrder from "@/hooks/useTruckingSalesOrder";
import { TruckingSalesOrderMapper } from "@/mapper/TruckingSalesOrder.mapper";
import MNotification from "@/mixins/MNotification.vue";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { ONE } from "@/models/constant/global.constant";
import {
  DATE_FORMAT_YYYY_MM_DD,
  DATE_TIME_HOURS_DEFAULT_FORMAT,
} from "@/models/constants/date.constant";
import { AssetStateEnum } from "@/models/enums/master-asset.enum";
import SALES_ORDER_STATUS from "@/models/enums/sales-order.enum";
import { TAX_CALCULATION } from "@/models/enums/tax.enum";
import { AddressDataDto } from "@/models/interface/contact-data";
import { AssetResponseDto } from "@/models/interface/master-asset";
import { AccountingTaxResponseDto } from "@/models/interface/master-tax";
import { IPreferencesResponseDto } from "@/models/interface/preference";
import { TaxBaseVariableParams } from "@/models/interface/tax-base-variable";
import {
  TruckingSalesOrderFormDto,
  TruckingSalesOrderLineFormDtoRow,
  TruckingSalesOrderRequestDto,
} from "@/models/interface/trucking-sales-order";
import { taxBaseVariableService } from "@/services/tax-base-variable.service";
import { LabelInValue } from "@/types";
import { RoundingUtils } from "@/utils/RoundingUtils";
import {
  formatterNumber,
  reverseFormatNumber,
} from "@/validator/globalvalidator";
import { FormModel } from "ant-design-vue";
import Decimal from "decimal.js-light";
import { Moment } from "moment";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import SelectBranch from "../custom/select/SelectBranch.vue";
import SelectCurrency from "../custom/select/SelectCurrency.vue";
import SelectCustomer from "../custom/select/SelectCustomer.vue";
import SelectTaxCalculation from "../custom/select/SelectTaxCalculation.vue";
import SelectTermOfPayment from "../custom/select/SelectTermOfPayment.vue";
import SelectTaxVatOut from "../Tax/SelectTaxVatOut.vue";
import DisplayTotal from "./DisplayTotal.vue";

@Component({
  computed: {
    ...mapState({
      storeBaseDecimalPlace: (st: any) =>
        st.preferenceStore.baseDecimalPlace as number,
    }),
  },
  components: {
    SelectBranch,
    SelectCustomer,
    SelectTaxCalculation,
    SelectCurrency,
    SelectTaxVatOut,
    DisplayTotal,
    SelectTermOfPayment,
  },
})
export default class FormMutate extends MNotification {
  @Prop({ type: String, required: false })
  id!: string;

  DATE_TIME_HOURS_DEFAULT_FORMAT = DATE_TIME_HOURS_DEFAULT_FORMAT;

  formatterNumber = formatterNumber;
  reverseFormatNumber = reverseFormatNumber;
  generateUUID = generateUUID;

  storeBaseDecimalPlace!: number;

  loading = {
    find: false,
    cancel: false,
    update: false,
    submit: false,
    draft: false,
    rounding: false,
    getTrucks: false,
    getTaxCodes: false,
  };

  @Ref("form")
  form!: FormModel;

  formData: TruckingSalesOrderFormDto = buildSalesOrderFormDto();
  shipToOptions: Option[] = [];
  billToOptions: Option[] = [];

  truckOptions: Option<AssetResponseDto>[] = [];
  taxCodeOptions: Option<AccountingTaxResponseDto>[] = [];

  defaultSalesInclusiveTax = {
    label: "",
    id: "",
    rate: 0,
  };

  formRules = {
    branch: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
        trigger: "change",
      },
    ],
    date: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
        trigger: "change",
      },
    ],
    customer: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
        trigger: "change",
      },
    ],
    shippingAddress: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
        trigger: "change",
      },
    ],
    billingAddress: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
        trigger: "change",
      },
    ],
    taxCalculation: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
        trigger: "change",
      },
    ],
    currency: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
        trigger: "change",
      },
    ],
    termOfPayment: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
        trigger: "change",
      },
    ],
    salesOrderLines: [
      {
        required: true,
        message: this.$t("lbl_validation_required_error"),
        trigger: "change",
      },
    ],
  };

  selectedRowKeys: string[] = [];

  get getColumns() {
    const columns = [
      {
        title: this.$t("lbl_document_reference"),
        dataIndex: "documentReference",
        width: "200px",
        scopedSlots: { customRender: "documentReference" },
      },
      {
        title: this.$t("lbl_part_number_unit_code"),
        dataIndex: "unitCode",
        width: "200px",
        scopedSlots: { customRender: "unitCode" },
      },
      {
        title: this.$t("lbl_serial_number"),
        dataIndex: "serialNumber",
        width: "200px",
        customRender: text => text || "-",
      },
      {
        title: this.$t("lbl_equipment"),
        dataIndex: "equipment",
        width: "200px",
        customRender: text => text || "-",
      },
      {
        title: this.$t("lbl_brand"),
        dataIndex: "brand",
        width: "200px",
        customRender: text => text || "-",
      },
      {
        title: this.$t("lbl_type"),
        dataIndex: "type",
        width: "200px",
        customRender: text => text || "-",
      },
      {
        title: this.$t("lbl_specification"),
        dataIndex: "specification",
        width: "200px",
        customRender: text => text || "-",
      },
      {
        title: this.$t("lbl_unit_of_measurement"),
        dataIndex: "unitOfMeasurement",
        width: "200px",
        customRender: text => text || "-",
      },
      {
        title: this.$t("lbl_quantity"),
        width: "200px",
        dataIndex: "qty",
        scopedSlots: { customRender: "qty" },
      },
      {
        title: this.$t("lbl_sales_name"),
        dataIndex: "salesName",
        width: "200px",
        scopedSlots: { customRender: "salesName" },
      },
      {
        title: this.$t("lbl_price"),
        width: "200px",
        dataIndex: "price",
        scopedSlots: { customRender: "price" },
      },
      {
        title: this.$t("lbl_gross_value"),
        width: "200px",
        dataIndex: "grossValue",
        customRender: (text: Decimal) => currencyFilter(text.toNumber()),
      },
      {
        title: this.$t("lbl_discount"),
        width: "200px",
        dataIndex: "discount",
        customRender: text => text || "-",
      },
      {
        title: this.$t("lbl_dpp"),
        width: "200px",
        dataIndex: "dpp",
        customRender: (text: Decimal) => currencyFilter(text.toNumber()),
      },
      {
        title: this.$t("lbl_tax_amount"),
        width: "200px",
        dataIndex: "taxAmount",
        customRender: (text: Decimal) => currencyFilter(text.toNumber()),
      },
      {
        title: this.$t("lbl_tax_code"),
        dataIndex: "taxCode",
        width: "250px",
        scopedSlots: { customRender: "taxCode" },
      },
      {
        title: this.$t("lbl_subtotal"),
        width: "200px",
        dataIndex: "subtotal",
        customRender: (text: Decimal) => currencyFilter(text.toNumber()),
      },
    ];

    if (this.isInclNonLuxury) {
      const index = columns.findIndex(item => item.dataIndex === "taxCode");
      columns.splice(index + 1, 0, {
        title: this.$t("lbl_inclusive_tax_code"),
        dataIndex: "inclusiveTax",
        width: "250px",
        scopedSlots: { customRender: "inclusiveTax" },
      });
    }
    return columns;
  }

  get isCreate(): boolean {
    return this.formData.status === ("" as SALES_ORDER_STATUS);
  }

  get isDraft(): boolean {
    return this.formData.status == SALES_ORDER_STATUS.DRAFT;
  }

  get isSubmitted(): boolean {
    return this.formData.status === SALES_ORDER_STATUS.SUBMITTED;
  }

  get isCreatedFromTruckingApp(): boolean {
    return !!this.formData.documentReference;
  }

  get isIdr(): boolean {
    return (
      !!this.formData.currency?.label && this.formData.currency?.label === "IDR"
    );
  }

  get isTaxNone(): boolean {
    return this.formData.taxCalculation?.key === TAX_CALCULATION.NONE;
  }

  get isTaxIncl(): boolean {
    return this.formData.taxCalculation?.key === TAX_CALCULATION.INCLUSIVE;
  }

  get isInclNonLuxury(): boolean {
    return (
      this.formData.taxCalculation?.key === TAX_CALCULATION.INCLUSIVE &&
      !this.formData.isLuxury
    );
  }

  get totalProps() {
    return {
      total: this.getTotalGross,
      totalDiscount: this.getTotalDiscount,
      totalTax: this.getTotalTax.toNumber(),
      grandTotal: this.getGrandTotal,
    };
  }

  get getTotalDpp(): Decimal {
    return this.formData.salesOrderLines.reduce<Decimal>(
      (curr, next) => curr.plus(next.dpp || 0),
      new Decimal(0)
    );
  }

  get getTotalGross(): number {
    const total = this.formData.salesOrderLines.reduce((total, line) => {
      return new Decimal(total).plus(line.grossValue || 0).toNumber();
    }, 0);
    return displayNeg(total);
  }

  get getTotalTax(): Decimal {
    return this.formData.salesOrderLines.reduce<Decimal>((curr, next) => {
      return curr.plus(next.taxAmount || 0);
    }, new Decimal(0));
  }

  get getTotalDiscount(): number {
    const { sum } = useCalculator();
    const total = sum(this.formData.salesOrderLines.map(e => e.discount || 0));
    return displayNeg(total);
  }

  get getGrandTotal(): number {
    const grandTotal = this.formData.salesOrderLines.reduce((total, line) => {
      return new Decimal(total).plus(line.subtotal).toNumber();
    }, 0);

    return displayNeg(grandTotal);
  }

  get isRoundingApplied(): boolean {
    return (
      this.formData.salesOrderLines.length > 0 &&
      this.formData.salesOrderLines.every(line => {
        const taxValue = line.taxAmount.toNumber();
        return Number.isInteger(taxValue);
      })
    );
  }

  get roundingButtonText(): string {
    return this.isRoundingApplied
      ? (this.$t("lbl_rounding_applied") as string)
      : (this.$t("lbl_apply_rounding") as string);
  }

  get roundingButtonIcon(): string | undefined {
    return this.isRoundingApplied ? "check" : undefined;
  }

  async created(): Promise<void> {
    await this.getDefaultSalesInclusiveTax();
    if (this.id) {
      this.getSalesOrderDetail();
    }

    this.getInitialSelectValues();
  }

  @Watch("isCreatedFromTruckingApp")
  onChangeIsCreatedFromTruckingApp(): void {
    if (!this.isCreatedFromTruckingApp) {
      return;
    }

    this.columns.push({
      title: this.$t("lbl_description"),
      width: "200px",
      dataIndex: "description",
      customRender: text => text || "-",
    });
  }

  //#region change handlers

  //#region customer change handler
  /**
   *
   * @description on SelectCustomer value change, set the shipping address, billing address, and default term of payment.
   */
  onCustomerChange(e?: LabelInValue): void {
    this.formData.termOfPayment = 0;
    this.form.clearValidate(["shippingAddress", "billingAddress"]);

    if (!e || !e.key) {
      return;
    }

    const customerId = String(e.key);

    const { findOne } = useContactData();
    findOne(customerId).then(cust => {
      const addresses: AddressDataDto[] = cust.addressDataList;

      this.setDefaultBillingAndShippingAddresses(addresses);
      this.setBillingAndShippingAddressOptions(addresses);
      this.formData.termOfPayment = cust.top || 0;
    });
  }

  setDefaultBillingAndShippingAddresses(addresses: AddressDataDto[]): void {
    const { getDefaultShipToAddress, getDefaultBillToAddress } =
      useContactData();

    const shipAddress = getDefaultShipToAddress(addresses);
    const billAddress = getDefaultBillToAddress(addresses);

    this.formData.shippingAddress = {
      key: shipAddress,
      label: shipAddress,
    };
    this.formData.billingAddress = {
      key: billAddress,
      label: billAddress,
    };
  }

  setBillingAndShippingAddressOptions(addresses: AddressDataDto[]): void {
    const { toShipToAddressOptions, toBillToAddressOptions } = useContactData();

    this.shipToOptions = toShipToAddressOptions(addresses);
    this.billToOptions = toBillToAddressOptions(addresses);
  }
  //#endregion

  /**
   * @description set serialNumber, type, uom, spec, equipment, and brand every time asset is selected
   */
  onAssetChange(
    e: Option<AssetResponseDto> | undefined,
    row: TruckingSalesOrderLineFormDtoRow
  ): void {
    const id = e?.key;
    if (!id) {
      row.serialNumber = "-";
      row.type = "-";
      row.unitOfMeasurement = "-";
      row.unitOfMeasurementId = "-";
      row.specification = "-";
      row.equipment = "-";
      row.brand = "-";
      return;
    }

    const asset = this.findAssetFromOptions(String(id), row);
    if (!asset) {
      return;
    }
    row.serialNumber = asset.serialNumber;
    row.type = asset.type;
    row.unitOfMeasurement = asset.uomName;
    row.unitOfMeasurementId = asset.uomId;
    row.specification = asset.description;

    const assetCategoryIdSegments = asset.assetCategory.id.split(".");
    row.equipment = assetCategoryIdSegments[0].toUpperCase() ?? "-";
    row.brand = assetCategoryIdSegments[1].toUpperCase() ?? "-";
  }

  findAssetFromOptions(
    id: string,
    row: TruckingSalesOrderLineFormDtoRow
  ): AssetResponseDto | undefined {
    const fromRow = row.truckOptions.find(e => id === e.key);
    if (fromRow) {
      return fromRow.meta;
    }

    const fromDefault = this.truckOptions.find(e => id === e.key);
    if (fromDefault) {
      return fromDefault.meta;
    }

    return undefined;
  }

  onTaxCodeChange(
    e: Option<AccountingTaxResponseDto> | undefined,
    row: TruckingSalesOrderLineFormDtoRow
  ): void {
    const id = e?.key;
    if (!id) {
      return;
    }

    const taxCode = this.findTaxCodeFromOptions(String(id), row);
    if (!taxCode) {
      return;
    }

    row.taxCode = {
      key: taxCode.id,
      label: taxCode.code,
    };
    row.taxRate = taxCode.rate || 0;

    this.calculateSalesOrderLines();
  }

  onChangeInclusiveTaxRate(
    row: TruckingSalesOrderLineFormDtoRow,
    val?: Option<AccountingTaxResponseDto>
  ): void {
    row.inclusiveTaxRate = 0;

    if (val) {
      row.inclusiveTaxRate = val.meta?.rate || 0;
    }

    this.calculateSalesOrderLines();
  }

  findTaxCodeFromOptions(
    id: string,
    row: TruckingSalesOrderLineFormDtoRow
  ): AccountingTaxResponseDto | undefined {
    const fromRow = row.taxCodeOptions.find(e => id === e.key);
    if (fromRow) {
      return fromRow.meta;
    }

    const fromDefault = this.taxCodeOptions.find(e => id === e.key);
    if (fromDefault) {
      return fromDefault.meta;
    }

    return undefined;
  }

  onSelectedTableRowChange(keys: string[]): void {
    this.selectedRowKeys = keys;
  }

  async onTaxCalculationChange(taxCalculation?: LabelInValue): Promise<void> {
    if (!taxCalculation) {
      return;
    }
    const { findByTaxRateAndType } = useTax();

    if (taxCalculation.key === TAX_CALCULATION.NONE) {
      this.resetTaxInclusive();
      findByTaxRateAndType(0, "VAT_OUT").then(taxOption => {
        this.formData.salesOrderLines.forEach(item => {
          item.taxCode = {
            key: taxOption.data[0]?.id ?? "",
            label: taxOption.data[0]?.code ?? "",
          };
          item.taxRate = taxOption.data[0]?.rate ?? 0;
        });

        this.calculateSalesOrderLines();
      });
    } else if (taxCalculation.key === TAX_CALCULATION.EXCLUSIVE) {
      this.resetTaxInclusive();
    } else if (taxCalculation.key === TAX_CALCULATION.INCLUSIVE) {
      if (this.formData.isLuxury) {
        this.useTaxCodeAsInclusive();
      } else {
        await this.setDefaultRowsInclusiveTax();
      }
      this.calculateSalesOrderLines();
    }
  }

  setDefaultRowsInclusiveTax(): void {
    if (!this.defaultSalesInclusiveTax.id) return;

    this.formData.salesOrderLines.forEach(item => {
      item.inclusiveTaxRate = this.defaultSalesInclusiveTax.rate;
      item.inclusiveTax = {
        label: this.defaultSalesInclusiveTax.label,
        key: this.defaultSalesInclusiveTax.id,
      };
    });
  }

  resetTaxInclusive(): void {
    this.formData.salesOrderLines.forEach(item => {
      item.inclusiveTaxRate = 0;
      item.inclusiveTax = undefined;
    });
  }

  onCurrencyChange(): void {
    const { findConversion } = useCurrency();
    const { findBaseCurrency } = usePreferences();

    const baseCurrency = findBaseCurrency();
    const defaultCurrency = baseCurrency?.name ?? "";

    const base = defaultCurrency;
    const to = this.formData.currency?.label ?? "";

    this.formData.currencyRate = ONE;
    if (!to || !base) return;
    findConversion(base, to).then(({ data }) => {
      const [curr] = data;
      this.formData.currencyRate = curr?.rate || ONE;
    });
  }
  //#endregion

  //#region truck event handling for each row
  onSearchTruck(
    record: TruckingSalesOrderLineFormDtoRow,
    value?: string
  ): void {
    debounce(() => {
      const builder = new SearchBuilder();
      const { filterBy } = useAsset();
      const params = new RequestQueryParams();
      const query: string[] = [this.buildTruckQuery()];
      const filtered: string = filterBy({ unitCode: value });

      if (filtered) {
        query.push(filtered);
      }

      params.search = query.join(builder.AND);

      record.loadingTrucks = true;

      this.fetchTruckOptions(params)
        .then(res => {
          record.truckOptions = res;
        })
        .finally(() => (record.loadingTrucks = false));
    });
  }

  buildTruckQuery(): string {
    const builder = new SearchBuilder();
    const q: string[] = [];

    q.push(
      builder.push(["status", AssetStateEnum.RETIRED], { not: true }).build()
    );

    q.push(
      builder
        .push(["assetCategory.categoryId", "truk"], { like: "end" })
        .build()
    );

    return q.join(builder.AND);
  }

  async fetchTruckOptions(
    params: RequestQueryParams = new RequestQueryParams()
  ): Promise<Option<AssetResponseDto>[]> {
    const { findAllAsset, toOptionsNew } = useAsset();
    const res = await findAllAsset(params);
    return toOptionsNew(res.data);
  }
  //#endregion

  //#region tax code event handling for each row
  onSearchTaxCode(
    record: TruckingSalesOrderLineFormDtoRow,
    value?: string
  ): void {
    debounce(() => {
      const { filterBy } = useTax();

      const params = new RequestQueryParams();
      const builder = new SearchBuilder();

      const query: string[] = [builder.push(["taxType", "VAT_OUT"]).build()];
      const filtered: string = filterBy({
        description: value,
      });
      if (filtered) {
        query.push(filtered);
      }
      params.search = query.join(new SearchBuilder().AND);

      record.loadingTaxCodes = true;

      this.fetchTaxCodeOptions(params)
        .then(res => {
          record.taxCodeOptions = res;
        })
        .finally(() => (record.loadingTaxCodes = false));
    });
  }

  async fetchTaxCodeOptions(
    params: RequestQueryParams = new RequestQueryParams()
  ): Promise<Option<AccountingTaxResponseDto>[]> {
    const { findCollections, toOptions } = useTax();
    const res = await findCollections(params);
    return toOptions(res.data);
  }
  //#endregion

  //#region button on click handlers
  /**
   * @description when adding row, set the default tax code and tax rate based on tax calculation and user preference
   */
  async handleAddRow(): Promise<void> {
    const { findById, findByTaxRateAndType } = useTax();

    const row = buildTruckingSalesOrderLineFormDto();
    row.key = this.formData.salesOrderLines.length;

    const salesTax: IPreferencesResponseDto | undefined =
      this.$store.getters["preferenceStore/getFeatSalesTaxRate"];
    const taxCalculation = this.formData.taxCalculation?.label;

    try {
      if (
        taxCalculation !== TAX_CALCULATION.NONE &&
        salesTax &&
        salesTax.value
      ) {
        const tax = await findById(salesTax.value);
        if (tax.id) {
          row.taxCode = {
            key: tax.id,
            label: tax.code,
          };
          row.taxRate = tax.rate || 0;
        }
      } else if (taxCalculation === TAX_CALCULATION.NONE) {
        const taxOption = await findByTaxRateAndType(0, "VAT_OUT");
        if (taxOption.data.length > 0) {
          row.taxCode = {
            key: taxOption.data[0].id,
            label: taxOption.data[0].code,
          };
          row.taxRate = taxOption.data[0].rate;
        }
      }
    } catch (error) {
      row.taxCode = undefined;
      row.taxRate = 0;
    }

    if (this.isTaxIncl && this.defaultSalesInclusiveTax.id) {
      row.inclusiveTax = {
        label: this.defaultSalesInclusiveTax.label,
        key: this.defaultSalesInclusiveTax.id,
      };
      row.inclusiveTaxRate = this.defaultSalesInclusiveTax.rate;
    }

    this.formData.salesOrderLines.push(row);
  }

  /**
   * @description when deleting row, store every deleted sales order line id to form data
   */
  handleDeleteRow(): void {
    this.showConfirmationDeleteItems(() => {
      this.formData.salesOrderLines = this.formData.salesOrderLines.filter(
        line => {
          const keep = !this.selectedRowKeys.includes(line.rowId);

          if (!keep && !!line.id) {
            this.formData.deletedSalesOrderLineIds.push(line.id);
          }

          return keep;
        }
      );

      this.selectedRowKeys = [];
      this.calculateSalesOrderLines();
    });
  }

  handleRounding(): void {
    this.loading.rounding = true;

    try {
      this.formData.salesOrderLines.forEach(line => {
        line.taxAmount = RoundingUtils.roundHalfUp(line.taxAmount, 0);

        line.subtotal = line.grossValue.plus(line.taxAmount);
        line.isRounded = true;
      });
    } catch {
      this.showNotifError("notif_process_fail");
    } finally {
      this.loading.rounding = false;
    }
  }

  handleBack(): void {
    this.$router.push({ name: "trucking.sales-order" });
  }

  handleSubmit(): void {
    this.validateForm(() => {
      if (this.formData.status === SALES_ORDER_STATUS.DRAFT) {
        this.submitSalesOrder();
      } else {
        this.createSalesOrder();
      }
    });
  }

  handleSaveDraft(): void {
    const { create } = useTruckingSalesOrder();

    const req: TruckingSalesOrderRequestDto =
      TruckingSalesOrderMapper.formModelToSalesOrderRequestDto(
        this.formData,
        this.getTotalDpp,
        this.getTotalTax,
        this.getTotalDiscount,
        this.getGrandTotal
      );
    req.state = SALES_ORDER_STATUS.DRAFT;

    this.loading.draft = true;
    create(req)
      .then(res => {
        this.showNotifSuccess("notif_create_success", {
          documentNumber: res.documentNumber,
        });
        this.handleBack();
      })
      .finally(() => {
        this.loading.draft = false;
      });
  }

  handleUpdate(): void {
    this.validateForm(async () => {
      const { update } = useTruckingSalesOrder();

      const req: TruckingSalesOrderRequestDto =
        TruckingSalesOrderMapper.formModelToSalesOrderUpdateRequestDto(
          this.formData,
          this.getTotalDpp,
          this.getTotalTax,
          this.getTotalDiscount,
          this.getGrandTotal
        );

      this.loading.update = true;
      update(this.id, req)
        .then(res => {
          this.formData.deletedSalesOrderLineIds = [];
          this.showNotifSuccess("notif_update_success", {
            documentNumber: res.documentNumber,
          });
          this.getSalesOrderDetail();
        })
        .finally(() => (this.loading.update = false));
    });
  }

  handleCancel(): void {
    const { cancel } = useSalesOrder();

    this.loading.cancel = true;
    cancel(this.id)
      .then(() => {
        this.showNotifSuccess("notif_cancel_success");
        this.handleBack();
      })
      .finally(() => {
        this.loading.cancel = false;
      });
  }
  //#endregion

  calculateSalesOrderLines(): void {
    const { countPrice } = useSalesOrderCalculation();
    const taxCalculation = this.formData.taxCalculation
      ?.label as TAX_CALCULATION;

    if (!taxCalculation) {
      return;
    }

    this.formData.salesOrderLines.forEach(line => {
      const { dpp, subtotal, taxAmount, grossValue } = countPrice({
        taxCalculation,
        price: line.price,
        qty: line.qty,
        discount: line.discount,
        taxRate: line.taxRate,
        taxBaseVariable: this.formData.taxBaseVariable,
        salesInclusiveTaxRate: line.inclusiveTaxRate,
        isLuxury: this.formData.isLuxury,
      });

      line.grossValue = grossValue;
      line.taxAmount = taxAmount;
      line.dpp = dpp;
      line.subtotal = subtotal;

      if (line.isRounded) {
        line.taxAmount = RoundingUtils.roundHalfUp(line.taxAmount, 0);
        line.subtotal = line.grossValue.plus(line.taxAmount);
      }
    });
  }

  createSalesOrder(): void {
    const { create } = useTruckingSalesOrder();

    const req: TruckingSalesOrderRequestDto =
      TruckingSalesOrderMapper.formModelToSalesOrderRequestDto(
        this.formData,
        this.getTotalDpp,
        this.getTotalTax,
        this.getTotalDiscount,
        this.getGrandTotal
      );
    req.state = SALES_ORDER_STATUS.SUBMITTED;

    this.loading.submit = true;
    create(req)
      .then(res => {
        this.showNotifSuccess("notif_submit_success", {
          documentNumber: res.documentNumber,
        });
        this.handleBack();
      })
      .finally(() => {
        this.loading.submit = false;
      });
  }

  submitSalesOrder(): void {
    const { submit } = useTruckingSalesOrder();

    const req: TruckingSalesOrderRequestDto =
      TruckingSalesOrderMapper.formModelToSalesOrderUpdateRequestDto(
        this.formData,
        this.getTotalDpp,
        this.getTotalTax,
        this.getTotalDiscount,
        this.getGrandTotal
      );
    this.loading.submit = true;

    submit(this.id, req)
      .then(res => {
        this.showNotifSuccess("notif_submit_success", {
          documentNumber: res.documentNumber,
        });
        this.handleBack();
      })
      .finally(() => (this.loading.submit = false));
  }

  validateForm(callback: () => void): void {
    this.form.validate((valid: boolean) => {
      const isSalesOrderLinesInvalid = !!this.formData.salesOrderLines.find(
        line => !line.unitCode
      );

      if (!valid || isSalesOrderLinesInvalid) {
        this.showNotifWarning("notif_validation_error");
        return;
      }

      callback();
    });
  }

  async getSalesOrderDetail(): Promise<void> {
    const { findById } = useSalesOrder();

    try {
      this.loading.find = true;
      const res = await findById(this.id);
      this.formData =
        TruckingSalesOrderMapper.salesOrderResponseDtoToFormModel(res);

      const variable = await this.getTaxBaseVariable({
        transactionDate:
          this.formData.date?.format(DATE_FORMAT_YYYY_MM_DD) ?? "",
        isLuxury: this.formData.isLuxury,
      });
      this.formData.taxBaseVariable = variable;
      // calculateSalesOrderLines() sengaja TIDAK dipanggil di sini — nilai
      // dari response sudah final (dpp/taxAmount/subtotal/grossValue).
      // Recalculate hanya dipicu oleh perubahan input asli (price, qty,
      // taxCode, taxCalculation, luxury, date, delete row).
    } catch {
      this.showNotifError("notif_process_fail");
    } finally {
      this.loading.find = false;
    }
  }

  getInitialSelectValues(): void {
    this.loading.getTrucks = true;
    const truckParams = new RequestQueryParams();
    truckParams.search = this.buildTruckQuery();
    this.fetchTruckOptions(truckParams)
      .then(res => (this.truckOptions = res))
      .finally(() => (this.loading.getTrucks = false));

    const params = new RequestQueryParams();
    const builder = new SearchBuilder();
    params.search = builder.push(["taxType", "VAT_OUT"]).build();
    this.loading.getTaxCodes = true;
    this.fetchTaxCodeOptions(params)
      .then(res => (this.taxCodeOptions = res))
      .finally(() => (this.loading.getTaxCodes = false));
  }

  async getDefaultSalesInclusiveTax(): Promise<void> {
    try {
      const { findByKey } = usePreferences();
      const response = findByKey("feature_sales_inclusive_tax_rate");
      if (!response || !response.value) {
        return;
      }
      const taxRate: number = await useTaxRate(response.value);
      this.defaultSalesInclusiveTax = {
        label: response.name,
        id: response.value,
        rate: taxRate,
      };
    } catch {
      this.defaultSalesInclusiveTax = {
        label: "",
        id: "",
        rate: 0,
      };
    }
  }

  async getTaxBaseVariable(params: TaxBaseVariableParams): Promise<number> {
    try {
      const response = await taxBaseVariableService.getVariable(params);
      return response.value ?? 1;
    } catch {
      return 1;
    }
  }

  async onChangeLuxury(val: boolean): Promise<void> {
    if (!this.formData.date) {
      this.formData.taxBaseVariable = 1;
      this.calculateSalesOrderLines();
      return;
    }

    const response = await this.getTaxBaseVariable({
      isLuxury: val,
      transactionDate: this.formData.date?.format(DATE_FORMAT_YYYY_MM_DD) ?? "",
    });
    this.formData.taxBaseVariable = response;

    if (val && this.isTaxIncl) {
      this.useTaxCodeAsInclusive();
    }

    this.calculateSalesOrderLines();
  }

  useTaxCodeAsInclusive(): void {
    for (const line of this.formData.salesOrderLines) {
      if (line.taxCode) {
        line.inclusiveTaxRate = line.taxRate;
        line.inclusiveTax = {
          label: line.taxCode.label,
          key: line.taxCode.key,
        };
      }
    }
  }

  async onChangeDate(val?: Moment): Promise<void> {
    if (!val) {
      this.formData.taxBaseVariable = 1;
      this.calculateSalesOrderLines();
      return;
    }

    const response = await this.getTaxBaseVariable({
      isLuxury: this.formData.isLuxury,
      transactionDate: val.format(DATE_FORMAT_YYYY_MM_DD) ?? "",
    });
    this.formData.taxBaseVariable = response;
    this.calculateSalesOrderLines();
  }
}
